import { notification } from 'antd';

import apiNetCore from '../services/apiNetCore';

export const searchEspeciesByProduto = async (
  idCliente,
  idProduto,
  setEspecies,
  setLoadingEspecies
) => {
  setEspecies([]);
  try {
    setLoadingEspecies(true);
    const { data } = await apiNetCore.post(
      '/EspecieAts/GetTodasEspeciesPorClienteForUiGrid',
      {
        Filters: [
          {
            Campo: 'IdCliente',
            Operador: 8,
            Valor: idCliente,
            CampoTipo: 2,
          },
          {
            Campo: 'IdProduto',
            Operador: 8,
            Valor: idProduto,
            CampoTipo: 2,
          },
          {
            Campo: 'Ativo',
            Operador: 8,
            Valor: 1,
            CampoTipo: 2,
          },
        ],
        Page: 1,
        Take: 100,
        Order: { Campo: 'Especie.Descricao', Operador: 0 },
      }
    );

    const especies = Array.isArray(data.data.items) ? data.data.items : [];

    setEspecies(especies);

    return especies;
  } catch (err) {
    notification.error({
      message: 'Ops, não conseguimos buscar os espécies.',
      description:
        'Caso o problema persista, entre em contato com nosso suporte.',
    });
  } finally {
    setLoadingEspecies(false);
  }
};
